<template>
  <div class="d-block mt-2 admin-menu">
    <span v-b-modal.modal-show-options class="float-right">
      <b-icon-grid class="text-success"></b-icon-grid>
    </span>

    <b-modal
      id="modal-show-options"
      size="sm"
      title="Options"
      hide-footer
      ok-only
    >
      <div class="row">
        <div class="col-12">
          <label>Block order reception</label>
          <b-button
            v-b-tooltip.hover
            title="Block order reception"
            class="float-right mb-2"
            @click="handleOffInvestor(investor_token, 0 ? is_on : 1)"
            style="font-size: 25px"
          >
            <b-icon-toggle-off class="text-success" v-if="show_button_off" />
            <b-icon-toggle-on class="text-success" v-else />
          </b-button>

          <b-button
            class="mr-2 my-1 btn-lg d-block w-100 text-left"
            v-b-modal.modal-connect-api-keys
            v-b-tooltip.hover
            title="Connect Api Keys"
            v-if="show_connect_api_keys"
          >
            Connect Api Keys
          </b-button>
        </div>

        <b-modal
          id="modal-connect-api-keys"
          size="md"
          title="Connect Api Keys"
          hide-footer
          ok-only
        >
          <div class="row pxr-2">
            <div class="col-md-12 mb-2 pxr-2">
              <div class="content">
                <label>Api key</label>
                <div class="row pxr-2" style="margin-top: 0px">
                  <div class="col-md-12 pxr-2">
                    <input
                      type="text"
                      class="form-control"
                      v-model="api_keys_form.api_key"
                      @input="$v.api_keys_form.api_key.$touch()"
                    />
                    <b-form-invalid-feedback
                      :state="$v.api_keys_form.api_key.required"
                      v-if="$v.api_keys_form.$dirty"
                    >
                      Required Field
                    </b-form-invalid-feedback>

                    <b-form-invalid-feedback
                      :state="$v.api_keys_form.api_key.minLength"
                      v-if="$v.api_keys_form.$dirty"
                    >
                      Min. 8 Characters
                    </b-form-invalid-feedback>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 mb-2 pxr-2">
              <div class="content">
                <label>Secret key</label>
                <div class="row pxr-2" style="margin-top: 0px">
                  <div class="col-md-12 pxr-2">
                    <input
                      type="text"
                      class="form-control"
                      v-model="api_keys_form.secret_key"
                      @input="$v.api_keys_form.secret_key.$touch()"
                    />

                    <b-form-invalid-feedback
                      :state="$v.api_keys_form.secret_key.required"
                      v-if="$v.api_keys_form.$dirty"
                    >
                      Required Field
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback
                      :state="$v.api_keys_form.secret_key.minLength"
                      v-if="$v.api_keys_form.$dirty"
                    >
                      Min. 8 Characters
                    </b-form-invalid-feedback>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 mb-2 pxr-2 d-flex">
              <b-button
                class="mt-3 ml-auto"
                variant="success"
                @click.prevent="save_api_keys"
                v-if="!loading_set_api_keys"
              >
                Save
              </b-button>

              <b-button
                v-else
                class="mt-3 ml-auto form-group pr-5"
                variant="dark"
                :disabled="true"
              >
                Save
                <div class="loading">
                  <b-spinner variant="light"></b-spinner>
                </div>
              </b-button>
            </div>
          </div>
        </b-modal>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";

export default {
  name: "OptionsRoleInvestor",
  validations: {
    api_keys_form: {
      api_key: {
        required,
        minLength: minLength(8),
      },
      secret_key: {
        required,
        minLength: minLength(8),
      },
    },
  },
  props: {
    investor_token: {
      type: String,
      required: true,
    },
    is_on: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {
    show_button_off() {
      return !this.$store.state.info_investor.info.investor
        .block_received_orders;
    },
    show_connect_api_keys() {
      if (!this.$store.state.user.token) {
        return false;
      }
      return this.$store.state.info_investor.info.set_api_keys;
    },
  },
  data() {
    return {
      api_keys_form: {
        api_key: "",
        secret_key: "",
      },
      error: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="20" height="20" rx="10" fill="#DC3545" fill-opacity="0.3"/>
			<path d="M12.4999 7.49992C12.4218 7.42181 12.3158 7.37793 12.2053 7.37793C12.0949 7.37793 11.9889 7.42181 11.9108 7.49992L9.99992 9.41076L8.08909 7.49992C8.01095 7.42181 7.90499 7.37793 7.79451 7.37793C7.68402 7.37793 7.57806 7.42181 7.49992 7.49992C7.42181 7.57806 7.37793 7.68402 7.37793 7.79451C7.37793 7.90499 7.42181 8.01095 7.49992 8.08909L9.41076 9.99992L7.49992 11.9108C7.42181 11.9889 7.37793 12.0949 7.37793 12.2053C7.37793 12.3158 7.42181 12.4218 7.49992 12.4999C7.57806 12.578 7.68402 12.6219 7.79451 12.6219C7.90499 12.6219 8.01095 12.578 8.08909 12.4999L9.99992 10.5891L11.9108 12.4999C11.9889 12.578 12.0949 12.6219 12.2053 12.6219C12.3158 12.6219 12.4218 12.578 12.4999 12.4999C12.578 12.4218 12.6219 12.3158 12.6219 12.2053C12.6219 12.0949 12.578 11.9889 12.4999 11.9108L10.5891 9.99992L12.4999 8.08909C12.578 8.01095 12.6219 7.90499 12.6219 7.79451C12.6219 7.68402 12.578 7.57806 12.4999 7.49992Z" fill="#1D1E25"/>
			</svg> Error`,
      loading_set_api_keys: false,
      loading_block_order_reception: false,
      success: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="20" height="20" rx="10" fill="#8BF125" fill-opacity="0.3"/>
          <g clip-path="url(#clip0_1634_940)">
          <path d="M14.2995 6.84625L8.5416 12.6038C8.50288 12.6426 8.45688 12.6735 8.40622 12.6945C8.35556 12.7155 8.30124 12.7264 8.24639 12.7264C8.19153 12.7264 8.13722 12.7155 8.08656 12.6945C8.0359 12.6735 7.98989 12.6426 7.95118 12.6038L5.72451 10.375C5.6858 10.3361 5.63979 10.3053 5.58913 10.2843C5.53848 10.2632 5.48416 10.2524 5.4293 10.2524C5.37445 10.2524 5.32013 10.2632 5.26947 10.2843C5.21881 10.3053 5.17281 10.3361 5.1341 10.375C5.09523 10.4137 5.06439 10.4597 5.04335 10.5104C5.02231 10.561 5.01147 10.6154 5.01147 10.6702C5.01147 10.7251 5.02231 10.7794 5.04335 10.83C5.06439 10.8807 5.09523 10.9267 5.1341 10.9654L7.3616 13.1925C7.59657 13.427 7.91501 13.5588 8.24701 13.5588C8.57901 13.5588 8.89745 13.427 9.13243 13.1925L14.8899 7.43625C14.9287 7.39755 14.9595 7.35157 14.9805 7.30095C15.0015 7.25033 15.0123 7.19606 15.0123 7.14125C15.0123 7.08645 15.0015 7.03218 14.9805 6.98156C14.9595 6.93094 14.9287 6.88496 14.8899 6.84625C14.8512 6.80739 14.8052 6.77655 14.7546 6.75551C14.7039 6.73446 14.6496 6.72363 14.5947 6.72363C14.5399 6.72363 14.4855 6.73446 14.4349 6.75551C14.3842 6.77655 14.3382 6.80739 14.2995 6.84625Z" fill="#1D1E25"/>
          </g>
          <defs>
          <clipPath id="clip0_1634_940">
          <rect width="10" height="10" fill="white" transform="translate(5 5)"/>
          </clipPath>
          </defs>
          </svg> Success`,
    };
  },
  methods: {
    handleOffInvestor(investor_token) {
      let data = {
        investor_token: this.$props.investor_token,
      };
      if (this.loading_block_order_reception) {
        this.$toastr.error(
          "Plese wait finish current proccess",
          `${this.error}`
        );
        return;
      }
      this.$http
        .server1("bwfs/investor/block_received_orders", data)
        .then((response) => {
          if (response.error) {
            this.$toastr.error(`${response.message}`, `${this.error}`);
            return;
          }
          this.$toastr.success(`${response.message}`, `${this.success}`);
          this.loading_block_order_reception = false;
          window.location.reload();
        });
    },
    save_api_keys() {
      if (
        this.$v.api_keys_form.secret_key.$invalid ||
        this.$v.api_keys_form.api_key.$invalid
      ) {
        this.$toastr.error(
          "Fulfill the field filling requirements",
          `${this.error}`
        );
        this.$v.$touch();
        return;
      }
      if (this.loading_set_api_keys) {
        this.$toastr.error(
          "Plese wait finish current proccess",
          `${this.error}`
        );
        return;
      }
      this.loading_set_api_keys = true;
      const data = {
        api_key: this.api_keys_form.api_key,
        secret_key: this.api_keys_form.secret_key,
        investor_token: this.$props.investor_token,
      };

      this.$http
        .server1("bwfs/investor/set_api_keys", data)
        .then((response) => {
          this.loading_set_api_keys = false;
          if (response.error) {
            this.$toastr.error(`${response.message}`, `${this.error}`);
            this.$v.$touch();
            return;
          }
          this.api_keys_form.api_key = "";
          this.api_keys_form.secret_key = "";
          this.$v.$reset();
          this.$toastr.success(`${response.message}`, `${this.success}`);
          this.$bvModal.hide("modal-connect-api-keys");
          window.location.reload();
        });
    },
  },
};
</script>
